export default "__VITE_ASSET__BYzb34qX__"